/* Roster de colaboradores: el panel solo conoce la IDENTIDAD (nombre, fase, tipo de salida).
   Los prompts viven en el companion y nunca llegan al navegador de Word. */

export interface AgentInfo {
  id: string;
  name: string;
  phase: string; // Concepto | Escritura | Reescritura | Publicación
  output: "rewrite" | "document" | "report";
  goal: string;
}

import { COMPANION, providerError } from "./companion";

export { PHASES, A_LA_VISTA, DE_ENTRADA, perfiles } from "./perfiles";

export async function fetchAgents(): Promise<AgentInfo[]> {
  const r = await fetch(`${COMPANION}/agents`);
  if (!r.ok) throw new Error(`Roster ${r.status}`);
  const { agents } = await r.json();
  return agents as AgentInfo[];
}

/** Pide un ENTREGABLE al colaborador: .docx en la carpeta del proyecto, se abre solo. */
export async function generateDeliverable(
  agentId: string,
  instruction: string,
  text: string,
  model: string,
  contextFiles: string[],
  saveDir: string,
  // El documento abierto: para que el registro diga de qué libro es el encargo.
  docPath: string | null = null,
): Promise<{ savedPath: string | null }> {
  const r = await fetch(`${COMPANION}/deliverable`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ agent: agentId, instruction, text, model, contextFiles, saveDir, docPath }),
  });
  if (!r.ok) {
    const t = await r.text().catch(() => "");
    throw new Error(providerError("Entregable", r.status, t));
  }
  return r.json();
}
